import axios from 'axios';

const axiosAssessmentApi = axios.create({
  baseURL: process.env.VUE_APP_API_ASS,
});

axiosAssessmentApi.interceptors.request.use(
  config => {
    let token = localStorage.getItem('plnbb_assessment_token');

    if (token) {
      config.headers['Authorization'] = 'Bearer ' + JSON.parse(token);
    }

    return config;
  },

  error => {
    return Promise.reject(error);
  },
);

export default axiosAssessmentApi;
